import { denormalize, normalize } from 'normalizr';
import { documentTemplateSchema } from './schema';
export const normalizeTemplatePayload = (payload)=>normalize(payload, documentTemplateSchema);
export const denormalizePayload = (payload)=>{
    const denormalizedData = denormalize({
        template: payload.template
    }, {
        template: documentTemplateSchema
    }, payload);
    return denormalizedData.template;
};
